var _desc, _defs, _rect, _rect2, _rect3, _circle, _g, _image, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreIntelligenceDashboardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390 650",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "FleetCore mobile fleet intelligence dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A commercial vehicle with verified driver, odometer and refuelling evidence, showing 98 percent fuel accounted for and no anomaly detected.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0B172C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030A18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "row",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0D1B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#071225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#21C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 22,
    height: 22,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.11,
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 387,
    height: 647,
    rx: 20,
    fill: "url(#panel)",
    stroke: "#6C7C96",
    strokeOpacity: 0.72,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 362,
    height: 622,
    rx: 15,
    fill: "none",
    stroke: "#91A0B8",
    strokeOpacity: 0.18
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 354,
    height: 285,
    rx: 14,
    fill: "url(#grid)",
    opacity: 0.72
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 180,
    r: 183,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0B8CFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 102V82h23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 102V82h-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 268v20h23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 268v20h-23"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 15,
    y: 75,
    width: 300,
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "fleetcore-commercial-van.png",
    href: "fleetcore-commercial-van.png"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(305 104)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 63,
    fill: "#030916",
    stroke: "#203754",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 58,
    fill: "none",
    stroke: "#122944",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 58,
    fill: "none",
    stroke: "url(#ring)",
    strokeWidth: 5.5,
    strokeLinecap: "round",
    strokeDasharray: "335 30",
    transform: "rotate(-88)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 68,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.38,
    strokeDasharray: "1.5 5"
  }), /*#__PURE__*/React.createElement("text", {
    y: -2,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 37,
    fontWeight: 760,
    textAnchor: "middle"
  }, "98%"), /*#__PURE__*/React.createElement("text", {
    y: 20,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9.5,
    textAnchor: "middle"
  }, "Fuel accounted for"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 318)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 65,
    rx: 11,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32.5,
    r: 19,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 26,
    r: 5.5,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 44c1.5-7 6-10 10-10s8.5 3 10 10",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 39,
    fill: "#FFFFFF",
    fontSize: 16
  }, "Driver verified"), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 32.5,
    r: 15,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317 32 5 5 10-12",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 393)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 65,
    rx: 11,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32.5,
    r: 19,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 37a13 13 0 1 1 24 0",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 33 7-7M22 28l3 2M40 28l-3 2M31 21v4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 33,
    r: 2.5,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 39,
    fill: "#FFFFFF",
    fontSize: 16
  }, "51 284 km"), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 32.5,
    r: 15,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317 32 5 5 10-12",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 468)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 65,
    rx: 11,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32.5,
    r: 19,
    fill: "#081A32",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19h12v27H24zM27 23h6v8h-6zM36 25h4l5 5v10c0 4-5 4-5 0v-7h-4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 39,
    fill: "#FFFFFF",
    fontSize: 16
  }, "63.2 L refuelled"), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 32.5,
    r: 15,
    fill: "#0866CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317 32 5 5 10-12",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 543)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 75,
    rx: 11,
    fill: "url(#row)",
    stroke: "#53647F",
    strokeOpacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 37.5,
    r: 20,
    fill: "#081A32",
    stroke: "#087CFF",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 24 41 28.5v8.5c0 7-4.5 12.5-10 16-5.5-3.5-10-9-10-16v-8.5L31 24Z",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 37 4 4 7-9",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 43,
    fill: "#FFFFFF",
    fontSize: 14.5
  }, "No fuel anomaly detected"), /*#__PURE__*/React.createElement("path", {
    d: "M242 38h82",
    stroke: "#087CFF",
    strokeOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 38,
    r: 3.5,
    fill: "#087CFF",
    filter: "url(#glow)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreIntelligenceDashboardMobile);
export default __webpack_public_path__ + "static/media/fleetcore-intelligence-dashboard-mobile.280d0429e651f198f971321322dfd03b.svg";
export { ForwardRef as ReactComponent };